/** Cognito lambda hook tunnel URL (legacy root `clientMetadata` on Amplify v4 configure). */
export function getCognitoClientMetadata() {
  const endpointOverride = process.env.REACT_APP_NGROK_API_URL
  if (!endpointOverride) {
    return undefined
  }
  return { endpointOverride }
}

/** v6 has no global configure clientMetadata; pass on each auth API (same effect as Amplify v4). */
export function withCognitoClientMetadataOptions(options = {}) {
  const clientMetadata = getCognitoClientMetadata()
  const mergedClientMetadata = {
    ...(clientMetadata || {}),
    ...(options.clientMetadata || {}),
  }
  if (Object.keys(mergedClientMetadata).length === 0) {
    return options
  }
  return {
    ...options,
    clientMetadata: mergedClientMetadata,
  }
}
